import { BonusPeriodInfoDto } from '../model'
import * as fromActions from './bonusperiod.actions'

export interface State {
  bonusPeriods: BonusPeriodInfoDto[]
  userBonusPeriods: BonusPeriodInfoDto[]
  activeBonusPeriod: BonusPeriodInfoDto | null
  userActiveBonusPeriod: BonusPeriodInfoDto | null
}

export const initialState: State = {
  bonusPeriods: [],
  userBonusPeriods: [],
  activeBonusPeriod: null,
  userActiveBonusPeriod: null,
} as State

export const reducer = (state = initialState, action: fromActions.default): State => {
  switch (action.type) {
    case fromActions.SET_ACTIVE_BONUS_PERIOD: {
      const { activeBonusPeriod, bonusPeriods } = action

      return { ...state, activeBonusPeriod, bonusPeriods }
    }

    case fromActions.SET_SELECTED_USER_ACTIVE_BONUS_PERIOD: {
      const { activeBonusPeriod: userActiveBonusPeriod, bonusPeriods: userBonusPeriods } = action

      return { ...state, userActiveBonusPeriod, userBonusPeriods }
    }

    default:
      return state
  }
}

export const getActiveBonusPeriod = (state: State) => state.activeBonusPeriod
export const getBonusPeriods = (state: State) => state.bonusPeriods
export const getUserActiveBonusPeriod = (state: State) => state.userActiveBonusPeriod
export const getUserBonusPeriods = (state: State) => state.userBonusPeriods



// WEBPACK FOOTER //
// ./src/app/shared/store/bonusperiod.reducer.ts